import { render, staticRenderFns } from "./PatientMembersList.vue?vue&type=template&id=24be98ac"
import script from "./PatientMembersList.vue?vue&type=script&lang=js"
export * from "./PatientMembersList.vue?vue&type=script&lang=js"
import style0 from "./PatientMembersList.vue?vue&type=style&index=0&id=24be98ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports